import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CompanyCommercialProductDTO } from '../models/commercialProduct.model';

@Injectable({
  providedIn: 'root'
})

export class CompanyCommercialProductService {

  constructor(private http: HttpClient) {
  }

  saveCompanyProducts(companyProducts: Array<CompanyCommercialProductDTO>): Promise<any> {
    return this.http.post<any>(environment.apiFullUrl + '/CompanyCommercialProduct/SaveCompanyProducts', companyProducts).toPromise()
  }

  NamirialPayAddOnSave(fk_company: number, companyProducts: CompanyCommercialProductDTO): Promise<any> {
    return this.http.post<any>(environment.apiFullUrl + '/CompanyCommercialProduct/NamirialPayAddOnSave/'+ fk_company, companyProducts).toPromise();    
  }

  NamirialPayAddOnDelete(id: number): Promise<any> {    
    return this.http.delete<any>(environment.apiFullUrl + '/CompanyCommercialProduct/NamirialPayAddOnDelete/' + id).toPromise();    
  }
 
}
